import React from 'react';
import { LucideIcon } from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  badge?: number;
  show?: boolean;
}

interface BottomNavigationProps {
  items: NavItem[];
  activeId: string;
  onChange: (id: string) => void;
}

/**
 * BottomNavigation Component v2 - FacturXPro Design System
 *
 * Navigation mobile avec style Teal/Volvo
 */
export const BottomNavigation: React.FC<BottomNavigationProps> = ({
  items,
  activeId,
  onChange,
}) => {
  const visibleItems = items.filter((item) => item.show !== false);

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/80 backdrop-blur-xl border-t border-gray-200/50 safe-area-bottom z-40 md:hidden">
      <div className="grid" style={{ gridTemplateColumns: `repeat(${visibleItems.length}, 1fr)` }}>
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeId === item.id;

          return (
            <button
              key={item.id}
              onClick={() => onChange(item.id)}
              className={`
                flex flex-col items-center justify-center py-2 px-2 transition-all duration-300
                touch-manipulation relative
                ${isActive ? 'text-teal-600' : 'text-gray-600 hover:text-gray-900'}
              `}
            >
              {/* Active indicator - Teal gradient */}
              {isActive && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-12 h-1 bg-gradient-to-r from-teal-500 to-teal-600 rounded-b-full" />
              )}

              <div className="relative">
                <Icon
                  className={`w-6 h-6 transition-transform duration-300 ${
                    isActive ? 'scale-110' : ''
                  }`}
                />
                {item.badge !== undefined && item.badge > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center font-bold">
                    {item.badge > 9 ? '9+' : item.badge}
                  </span>
                )}
              </div>

              <span className={`text-xs mt-1 font-medium truncate max-w-full ${isActive ? 'font-semibold text-teal-700' : ''}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
